module.exports = __webpack_public_path__ + "static/media/xuwenjuan.d27e6d24.png";